// import COMPANY_API from '@/api/masterData/company.js';

export const formFields = (ctx) => {
  return [
    // {
    //   prop: 'statementCompanyNo',
    //   name: '公司名称',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_COMPANY_LIST_API,
    //   apiData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'companyCode',
    //   labelKey: 'companyName',
    //   changeMethod: 'changeCompanyHandler',
    //   valueType: 'object',
    //   method: 'post',
    // },
    // {
    //   prop: 'statementDepartmentNo',
    //   name: '部门',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
    //   apiData: {
    //     belongCompanyCode: ctx.baseFormData.statementCompanyNo,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   disabled: ctx.baseFormData.statementCompanyNo == '',
    //   valueKey: 'createDepartmentCode',
    //   labelKey: 'departmentName',
    //   changeMethod: 'changeDepartmentHandler',
    //   method: 'post',
    //   valueType: 'object',
    // },
    // {
    //   name: '客户名称',
    //   prop: 'customerName',
    //   type: 'searchTableSpec',
    //   searchType: 'sapCustomer',
    //   isMultiple: true,
    //   changeMethod: ctx.changeCustomsMethod,
    // },
    // {
    //   name: '合同编号',
    //   prop: 'contractNo',
    //   type: 'input',
    // },
    {
      prop: 'businessCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      disabled: true,
      changeMethod: ctx.changeCompanyHandler,
    },
    {
      prop: 'businessDepartmentCode',
      name: '部门',
      type: 'select',
      // disabled: ctx.query?.businessCompanyNo == '',
      disabled: true,
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'multransportContract',
      disabled: true,
      extraData: {
        // contractStatus: 'ZT03',
        contractType: '0',
        isCS: 'S',
        businessDepartmentCode: ctx.query.businessDepartmentCode,
        platformCompanyName: ctx.businessCompanyName,
      },
      isMultiple: true,
      changeMethod: ctx.changeContractMethod,
      currentValue: ctx.query?.contractNo,
    },
    {
      name: '业务类别',
      prop: 'businessCategory',
      type: 'select',
      disabled: true,
      options: ctx.dictListMap?.businessCategoryPayable || [],
    },
    {
      name: '状态',
      prop: 'processStatus',
      type: 'select',
      disabled: true,
      options: [
        {
          label: '未处理',
          value: '0',
        },
        {
          label: '已处理',
          value: '1',
        },
      ],
    },
    {
      prop: 'productType',
      name: '产品',
      type: 'select',
      disabled: true,
      options: ctx.productList,
      changeMethod: ctx.changeProductTypeHandler,
    },
    {
      prop: 'serviceType',
      name: '服务',
      type: 'select',
      disabled: true,
      options: ctx.serviceAllList,
      changeMethod: ctx.changeServiceTypeHandler,
    },

    {
      prop: 'expenseType',
      name: '费用类型',
      type: 'select',
      disabled: true,
      // type: 'selectMultiple',
      // isMultiple: true,
      options: ctx.expenseTypeList,
    },
    // {
    //   name: '供应商名称',
    //   prop: 'supplierNo',
    //   type: 'searchTableSpec',
    //   searchType: 'partner',
    //   extraData: {
    //     companyCode: ctx.query.businessCompanyNo,
    //     departmentCode: ctx.query.businessDepartmentCode,
    //     partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeSupplyChainMethod,
    // },
    {
      name: '订单编号',
      prop: 'orderCode',
      disabled: true,
      type: 'input',
    },
    {
      name: '指令单编号',
      prop: 'instructionNoLike',
      type: 'input',
    },
    {
      name: '费用编号',
      prop: 'expenseNoLike',
      type: 'input',
    },

    // {
    //   // 申请日期从
    //   name: '指令下发日期从',
    //   prop: 'instructionIssueDateStart',
    //   type: 'startDaterangePicker',
    // },
    // {
    //   // 申请日期到
    //   name: '指令下发日期至',
    //   prop: 'instructionIssueDateEnd',
    //   type: 'endDaterangePicker',
    // },
    {
      name: '费用生成日期从',
      prop: 'expenseGenerationDateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '费用生成日期至',
      prop: 'expenseGenerationDateEnd',
      type: 'endDaterangePicker',
    },
  ];
};

export const tableColumnList = [
  {
    field: 'expenseNo',
    title: '费用编号',
    width: '120',
  },
  {
    field: 'expenseTypeName',
    title: '费用类型',
    width: '120',
  },
  {
    field: 'originalPrice',
    title: '原币结算单价(含税)',
    visible: true,
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    visible: true,
  },
  {
    field: 'unitName',
    title: '计量单位',
    visible: true,
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额(含税)',
    visible: true,
  },
  {
    field: 'businessCompanyName',
    title: '公司名称',
    visible: true,
  },
  {
    field: 'businessDepartmentName',
    title: '部门名称',
    visible: true,
  },
  {
    field: 'supplierName',
    title: '供应商名称',
    visible: true,
    width: '150',
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'expenseGenerationDate',
    title: '费用生成日期',
    width: '160',
  },

  {
    field: 'orderCode',
    title: '订单编号',
    width: '160',
  },
  {
    title: '指令单编号',
    field: 'instructionNo',
    width: '160',
  },
  {
    field: 'productTypeName',
    title: '产品',
    visible: true,
    width: '150',
  },
  {
    field: 'serviceTypeName',
    title: '服务',
    visible: true,
    width: '150',
  },
  {
    field: 'accountPeriod',
    title: '应收账期',
    visible: true,
    width: '150',
  },
  {
    field: 'createMethod',
    title: '创建方式',
    visible: true,
  },
  {
    field: 'abnormalExpenseFlag',
    title: '是否是异常费用',
    visible: true,
  },
  {
    field: 'confirmStatus',
    title: '确认状态',
    visible: true,
  },
  {
    field: 'processStatus',
    title: '状态',
    visible: true,
  },
  {
    field: 'settlementNo',
    title: '对账单编号',
    visible: true,
  },
  {
    field: 'salesmanName',
    title: '业务员',
    width: '140',
  },
  // {
  //   field: 'productModel',
  //   title: '规格',
  //   width: '140',
  //   editRender: { name: 'productModel' },
  // },

  // {
  //   field: 'remark',
  //   title: '备注',
  //   width: '140',
  //   editRender: { name: 'remark' },
  // },
];
